<template>
  <div 
    id="replay"
    @dragover.prevent="setDropEffect"
    @drop.prevent="handleFileUpload">
    <Viewport/>
  </div>
</template>

<script>
import Viewport from './Viewport'
import { mapActions } from 'vuex'

export default {
  name: 'Replay',
  components: {
    Viewport,
  },
  created() {
    window.addEventListener('resize', this.handleWindowResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    ...mapActions(['handleWindowResize', 'handleFileUpload']),
    setDropEffect(dragOverEvent) {
      dragOverEvent.dataTransfer.dropEffect = 'copy'
    },
  },
}
</script>
